// extracted by css-extract-rspack-plugin
export default {"settingsButtonWrapper":"settings-button-wrapper--FbmIMrqBIKz6IQ3l","resumeSearchForm":"resume-search-form--GeUqX3quTgg_9Itm"};